<!doctype html>
<html lang="en">
  <!-- <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
      rel="stylesheet" />
  </head> -->

  <body id="pdf-data" #pdfContent>
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"auto"}'>
          <img
            alt="Org logo"
            [src]="sheetData?.logo"
            style="width: 125px; height: auto; object-fit: contain" />
        </div>
        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ sheetData?.orgDetail.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ sheetData?.orgDetail.city }}, {{ sheetData?.orgDetail.state }},
            {{ sheetData?.orgDetail.country }},
            {{ sheetData?.orgDetail.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div
        data-pdfmake='{"width":"*", "margin": [10, 0]}'
        style="text-align: center">
        <h5>{{ sheetData?.datasheetInfo.title }}</h5>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ sheetData?.caseDetail.student.firstName }}
          {{ sheetData?.caseDetail.student.lastName }}
        </div>
        <div style="width: auto">
          <!-- <table><tr><th>Table</th><tr><tr><td>Centered</td></tr></table> -->
        </div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ sheetData?.caseDetail.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">
            Gender:
            <b> {{ sheetData?.caseDetail.student.gender }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">
            Date Of Birth:
            <b>{{
              sheetData?.caseDetail.student.dateOfBirth ?? null
                | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Location:</div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date:</div>
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div data-pdfmake-type="columns">
        <div
          data-pdfmake='{
        "color": "#128E55","width":147
    }'>
          <b> Challenging Behavior :</b>
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{ sheetData?.behavior?.behaviorCategoryName }} </b>
          <b>{{
            sheetData?.behaviorNames?.length > 0
              ? '=>' + sheetData?.behaviorNames.join(', ')
              : ''
          }}</b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">
          Operational Definition :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{
              sheetData?.behavior.operationalDefinition || 'Nothing Entered'
            }}
          </b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns" *ngIf="sheetData?.datasheetInfo.details">
        <div data-pdfmake='{"width":130}' class="datalabel">
          Replacement Behavior :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <ul>
            <li
              [attr.data-pdfmake]="
                generateLI(sheetData?.datasheetInfo.details)
              "></li>
          </ul>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":130}' class="datalabel">Instructions :</div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <ul>
            <li
              *ngFor="let item of sheetData?.datasheetInfo.instructions"
              [attr.data-pdfmake]="generateLI(item)"></li>
          </ul>
        </div>
      </div>
      <div data-pdfmake-type="columns" *ngIf="sheetData?.datasheetInfo.note">
        <div data-pdfmake='{"width":130}' class="datalabel"></div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <ul>
            <li
              [attr.data-pdfmake]="
                generateLI(sheetData?.datasheetInfo.note)
              "></li>
          </ul>
        </div>
      </div>
      <br />
      <div
        data-pdfmake-type="columns"
        *ngIf="sheetData?.datasheetInfo.unit === 3">
        <div data-pdfmake='{"width":150}' class="datalabel">Date :</div>
        <div data-pdfmake='{"width":"*"}' class="datalabel"></div>
      </div>
      <br />
      <div
        [attr.data-pdfmake]="generateTable(sheetData)"
        *ngIf="sheetData?.datasheetInfo.unit !== 3"></div>
      <div
        [attr.data-pdfmake]="generateaPartialTable()"
        *ngIf="sheetData?.datasheetInfo.unit === 3"></div>

      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":150}' class="datalabel">
          Comments/Notes :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel"></div>
      </div>
    </div>
  </body>
</html>
